import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, MapPin } from 'lucide-react';
import { heroData } from '../../data/mock';

const HeroSection = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  const scrollToContent = () => {
    const aboutSection = document.getElementById('about-section');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen min-h-[700px] w-full overflow-hidden">
      {/* Background Image with Parallax Effect */}
      <div className="absolute inset-0">
        <div
          className={`absolute inset-0 transition-transform duration-[2000ms] ease-out ${
            isLoaded ? 'scale-100' : 'scale-110'
          }`}
        >
          <img
            src={heroData.backgroundImage}
            alt="Italian landscape"
            className="w-full h-full object-cover"
          />
        </div>
        {/* Gradient Overlays */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70" />
      </div>

      {/* Content */}
      <div className="relative h-full flex flex-col justify-center items-center text-center px-6">
        <div
          className={`max-w-3xl transition-all duration-1000 delay-500 ${
            isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif text-white leading-tight mb-4">
            {heroData.title}
            <span className="block text-amber-200/90 mt-1 italic">{heroData.subtitle}</span>
          </h1>
          <p className="text-lg md:text-xl text-white/80 mb-10 max-w-2xl mx-auto font-light leading-relaxed">
            {heroData.description}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/destinations"
              className="px-8 py-4 bg-white text-stone-900 rounded-full text-base font-medium hover:bg-amber-50 transition-all duration-300 hover:shadow-xl"
            >
              Explore Destinations
            </Link>
            <button
              onClick={scrollToContent}
              className="px-8 py-4 text-white border border-white/30 rounded-full text-base font-medium hover:bg-white/10 transition-all duration-300"
            >
              How It Works
            </button>
          </div>
        </div>

        {/* Scroll Indicator */}
        <button
          onClick={scrollToContent}
          className={`absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/70 hover:text-white transition-all duration-300 group cursor-pointer ${
            isLoaded ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <ChevronDown className="w-6 h-6 animate-bounce" />
        </button>

        {/* Location Badge */}
        <div
          className={`absolute bottom-12 right-8 hidden lg:flex items-center gap-2 text-white/60 transition-all duration-1000 delay-1000 ${
            isLoaded ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <MapPin className="w-4 h-4" />
          <span className="text-sm">{heroData.location}</span>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
